
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as PrismicPreviewHQ8wvsCY32Meta } from "/opt/build/repo/node_modules/.pnpm/@nuxtjs+prismic@4.1.0_magicast@0.3.5_vite@6.1.1_@types+node@22.13.4_jiti@2.4.2_sass-emb_e46325236d563edb2dfeba36f8444782/node_modules/@nuxtjs/prismic/dist/runtime/PrismicPreview.vue?macro=true";
import { default as indexlaFeZuYZkUMeta } from "/opt/build/repo/pages/index.vue?macro=true";
import { default as slice_45simulatoraGnv8AQLQlMeta } from "/opt/build/repo/pages/slice-simulator.vue?macro=true";
import { default as component_45stubMLQMYqXXCSMeta } from "/opt/build/repo/node_modules/.pnpm/nuxt@3.15.4_@parcel+watcher@2.5.1_@types+node@22.13.4_db0@0.2.4_eslint@9.20.1_jiti@2.4._6188dd1bc96df6f98ff3c540694b8bce/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubMLQMYqXXCS } from "/opt/build/repo/node_modules/.pnpm/nuxt@3.15.4_@parcel+watcher@2.5.1_@types+node@22.13.4_db0@0.2.4_eslint@9.20.1_jiti@2.4._6188dd1bc96df6f98ff3c540694b8bce/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "prismic-preview___de___default",
    path: "/preview",
    component: () => import("/opt/build/repo/node_modules/.pnpm/@nuxtjs+prismic@4.1.0_magicast@0.3.5_vite@6.1.1_@types+node@22.13.4_jiti@2.4.2_sass-emb_e46325236d563edb2dfeba36f8444782/node_modules/@nuxtjs/prismic/dist/runtime/PrismicPreview.vue")
  },
  {
    name: "prismic-preview___de",
    path: "/de/preview",
    component: () => import("/opt/build/repo/node_modules/.pnpm/@nuxtjs+prismic@4.1.0_magicast@0.3.5_vite@6.1.1_@types+node@22.13.4_jiti@2.4.2_sass-emb_e46325236d563edb2dfeba36f8444782/node_modules/@nuxtjs/prismic/dist/runtime/PrismicPreview.vue")
  },
  {
    name: "prismic-preview___en",
    path: "/en/preview",
    component: () => import("/opt/build/repo/node_modules/.pnpm/@nuxtjs+prismic@4.1.0_magicast@0.3.5_vite@6.1.1_@types+node@22.13.4_jiti@2.4.2_sass-emb_e46325236d563edb2dfeba36f8444782/node_modules/@nuxtjs/prismic/dist/runtime/PrismicPreview.vue")
  },
  {
    name: "index___de___default",
    path: "/",
    meta: indexlaFeZuYZkUMeta || {},
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    meta: indexlaFeZuYZkUMeta || {},
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexlaFeZuYZkUMeta || {},
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "slice-simulator___de___default",
    path: "/slice-simulator",
    component: () => import("/opt/build/repo/pages/slice-simulator.vue")
  },
  {
    name: "slice-simulator___de",
    path: "/de/slice-simulator",
    component: () => import("/opt/build/repo/pages/slice-simulator.vue")
  },
  {
    name: "slice-simulator___en",
    path: "/en/slice-simulator",
    component: () => import("/opt/build/repo/pages/slice-simulator.vue")
  },
  {
    name: component_45stubMLQMYqXXCSMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubMLQMYqXXCS
  },
  {
    name: component_45stubMLQMYqXXCSMeta?.name,
    path: "/de/sitemap.xml",
    component: component_45stubMLQMYqXXCS
  },
  {
    name: component_45stubMLQMYqXXCSMeta?.name,
    path: "/en/sitemap.xml",
    component: component_45stubMLQMYqXXCS
  },
  {
    name: component_45stubMLQMYqXXCSMeta?.name,
    path: "/index-sitemap.xml",
    component: component_45stubMLQMYqXXCS
  },
  {
    name: component_45stubMLQMYqXXCSMeta?.name,
    path: "/de/index-sitemap.xml",
    component: component_45stubMLQMYqXXCS
  },
  {
    name: component_45stubMLQMYqXXCSMeta?.name,
    path: "/en/index-sitemap.xml",
    component: component_45stubMLQMYqXXCS
  },
  {
    name: component_45stubMLQMYqXXCSMeta?.name,
    path: "/de-de-sitemap.xml",
    component: component_45stubMLQMYqXXCS
  },
  {
    name: component_45stubMLQMYqXXCSMeta?.name,
    path: "/de/de-de-sitemap.xml",
    component: component_45stubMLQMYqXXCS
  },
  {
    name: component_45stubMLQMYqXXCSMeta?.name,
    path: "/en/de-de-sitemap.xml",
    component: component_45stubMLQMYqXXCS
  },
  {
    name: component_45stubMLQMYqXXCSMeta?.name,
    path: "/en-de-sitemap.xml",
    component: component_45stubMLQMYqXXCS
  },
  {
    name: component_45stubMLQMYqXXCSMeta?.name,
    path: "/de/en-de-sitemap.xml",
    component: component_45stubMLQMYqXXCS
  },
  {
    name: component_45stubMLQMYqXXCSMeta?.name,
    path: "/en/en-de-sitemap.xml",
    component: component_45stubMLQMYqXXCS
  }
]